import React, { useEffect, useState } from 'react';
import { Dialog, DialogActions, DialogContent, TextField, Switch, FormControlLabel, Chip, Avatar } from '@mui/material';
import { Edit, Person } from '@mui/icons-material';
import { useAppData } from '../../../../../context/AppDataContext';
import AppSelect from '../../../../../components/AppInput/AppSelect';
import projectContributorServices from '../projectContributorServices';
import { useAlert } from '../../../../../context/AlertContext';

const ProjectContributorBadge = ({ projectId }) => {
    const [dialogStatus, setDialogStatus] = useState(false);
    const [notify, setNotify] = useState(false);
    const [remark, setRemark] = useState("");
    const [inputUser,setInputUser] = useState(null);
    const { userDD,getDDDataById } = useAppData();
    const {AppAlert} = useAlert();


    const [contributorList,setContributorList] = useState([]);
    const getContributorlist = () =>{
        projectContributorServices.getByProjectId(projectId).then(res=>{
            setContributorList(res.data)
        }).catch(error=>{

        })
    }

    useEffect(()=>{
        getContributorlist();
    },[projectId])


    const addContributor = () =>{
        if(inputUser !== null){
            let payload = {
                projectId:projectId,
                contributorId:inputUser.value,
            }
            projectContributorServices.save(payload).then(res=>{
                getContributorlist();
                AppAlert(res.msg);
            }).catch(error=>{
                AppAlert(error.msg,"error");
            })
        }
    }

    const removeContributor = (contributor) =>{
        projectContributorServices.remove(contributor.id).then(res=>{
            getContributorlist();
            AppAlert(res.msg);
        }).catch(error=>{
            AppAlert(error.msg,"error");
        })
    }

    const handleUpdate = () => {
        addContributor();
        
        setDialogStatus(false);
        setRemark("");
    };

    return (
        <>
            <div>
                
                {contributorList.length === 0  && "No Contributor Assigned"}
                {contributorList?.map(contributor=>
                    <Chip 
                        avatar={<Avatar sx={{ width: 24, height: 24 }}><Person fontSize="small" /></Avatar>}
                        label={getDDDataById(userDD, contributor.contributorId)?.label}
                        onDelete={()=>removeContributor(contributor)}
                    />
                )}
                <button className='btn btn-link' onClick={()=>setDialogStatus(true)}>Add Contributor</button>
            </div>
            

            
                <Dialog
                    open={dialogStatus}
                    onClose={() => setDialogStatus(false)}
                    fullWidth={true}
                    maxWidth="xs"
                    
                >
                    <div className='p-3 fw-bold border-bottom'>Add Contributor</div>
                    <DialogContent>
                        <div className='row mt-2 ' style={{minHeight:400}}>
                            <div className='col-md-12'>
                                {/* User Selection */}
                                <AppSelect 
                                    options={userDD}
                                    value={inputUser}
                                    setValue={setInputUser}
                                    label="Select Contributor"
                                />
                            </div>
                        </div>
                    </DialogContent>
                    <DialogActions className="p-3">
                        <button className='btn btn-light' onClick={() => setDialogStatus(false)}>Cancel</button>
                        <button className='btn btn-primary' onClick={handleUpdate}>Add Contributor</button>
                    </DialogActions>
                </Dialog>
            
        </>
    );
};

export default ProjectContributorBadge;